__turbopack_context__.v({
  "buttons": "WindowsPopup-module__dLIxZq__buttons",
  "main": "WindowsPopup-module__dLIxZq__main",
});
